const PaginateButton = ({ className, onClick, disabled, icon }: any) => {
  return (
    <button className={className} onClick={onClick} disabled={disabled}>
      {icon()}
    </button>
  )
}

export { PaginateButton }
